export * from "./ErrorBoundary";
export * from "./Money";
export * from "./UpDownInput";
export * from "./Loading";
export * from "./PageControl";

export * from "./Icons";
export * from "./DropZone";
export * from "./ProgressBar"
export * from "./useMatchMedia"
export * from "./Contact/ContactUs"
export * from "./Contact/ContactLinks"





export function createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
